<template>
    <page :empty="!articles.length > 0" :empty-text="empty">
        <template slot="header">
            <h1>Angebote</h1>
        </template>
        <articles :articles="articles"></articles>
    </page>
</template>

<script type="text/babel">
import articles from './Articles/Listing.vue';
import page from './Page.vue';

export default {
  data() {
    return {
      empty: 'Leider gibt es derzeit keine Angebote.',
    };
  },
  components: {
    articles,
    page,
  },
  computed: {
    articles() {
      return this.$store.getters.getOffers;
    },
  },
};
</script>

<style type="scss">
</style>
